import PropTypes from 'prop-types';

import ChannelListings from '../../components/Channels/ChannelListings';
import { CHANNELS_LIST_QUERY } from '../../components/Channels/ChannelFinderQuery';
import { WHERE_TO_WATCH_QUERY } from '../../components/Channels/WhereToWatchPageQuery';
import CorusImage from '../../components/CorusImage/CorusImage';
import AdobeAnalyticsDataLayer from '../../components/AdobeAnalytics/AdobeAnalyticsDataLayer';
import SeoYoast from '../../components/Seo/SeoYoast';
import SeoJsonLdChannel from '../../components/Seo/Json/SeoJsonLdChannel';
import { SEO_QUERY_CHANNEL } from '../../components/Seo/Queries/SeoQueryChannel';

import * as utility from '../../utils/utility';
import { initializeApollo } from '../../utils/apolloClient';
import { fetchSeoMeta } from '../../utils/fetchSeoMeta';

export default function WhereToWatch({
	id = '', date = '', modifiedDate = '', title = '', channels = '', streams = '', seoJsonSchema = '', pageSeo = {},
}) {
	return (
		<>
			<SeoYoast seo={pageSeo?.seo} />
			<SeoJsonLdChannel seoJsonSchema={seoJsonSchema} />
			<AdobeAnalyticsDataLayer
				viewType="content"
				contentID={id}
				contentType="page"
				contentCreatedDate={date}
				contentPublishedDate={date}
				contentModifiedDate={modifiedDate}
				contentTitle={title}
			/>
			<div className="banner">
				<div className="title">
					<CorusImage
						alt="Where To Watch"
						className="wtw-img"
						height={90}
						src="/images/WTW.svg"
						title="Where To Watch"
						width={429}
					/>
				</div>
			</div>
			<div className="where-to-watch">
				<h2>Looking for Flavour Network full episodes?  See them all here.</h2>
				{ (utility.arrayHasItems(channels)) && <ChannelListings title="Stream Online" channels={channels} /> }
				{ (utility.arrayHasItems(streams)) && <ChannelListings title="WATCH THROUGH A TELEVISION SERVICE PROVIDER" channels={streams} /> }
			</div>
		</>
	);
}

export const getServerSideProps = async () => {
	const apolloClient = initializeApollo();

	const { data } = await apolloClient.query({
		query: CHANNELS_LIST_QUERY,
		errorPolicy: 'all',
	});

	// Fetch Page Yoast SEO Meta
	const pageSeo = await fetchSeoMeta('/where-to-watch');

	const { data: seoSchema } = await apolloClient.query({
		query: SEO_QUERY_CHANNEL,
		errorPolicy: 'all',
	});

	const { data: pageData } = await apolloClient.query({
		query: WHERE_TO_WATCH_QUERY,
		variables: {
			id: 'where-to-watch',
			idType: 'URI',
		},
		errorPolicy: 'all',
	});

	const {
		databaseId,
		modified,
		date,
		title,
	} = pageData?.page;

	if (!data?.channels?.edges || !seoSchema) return { notFound: true };

	const channels = data?.channels?.edges.filter(
		(edge) => edge?.node?.channelFinder?.onlineStreamingChannel,
	);

	const streams = data?.channels?.edges.filter(
		(edge) => edge?.node?.channelFinder?.onlineStreamingChannel !== true,
	);

	const seo = seoSchema?.seo;

	return {
		props: {
			initialApolloState: apolloClient.cache.extract(),
			id: databaseId,
			date,
			modifiedDate: modified,
			title,
			channels,
			streams,
			seoJsonSchema: seo?.contentTypes?.channel?.schema?.raw ?? null,
			pageSeo,
		},
	};
};

WhereToWatch.propTypes = {
	id: PropTypes.number,
	date: PropTypes.string,
	modifiedDate: PropTypes.string,
	title: PropTypes.string,
	channels: PropTypes.array,
	streams: PropTypes.array,
	seoJsonSchema: PropTypes.string,
	pageSeo: PropTypes.object,
};
